import { EGeocodeStatus } from '../../types/filters';
import { IApplicationState } from '../../types/redux';
import { TSutochnoRegionType } from '../../types/sutochnoPilot';
import { selectIsGeoLoading } from '../filters';

export function selectSutochnoRegionType(state: IApplicationState): TSutochnoRegionType {
  const {
    filters: {
      jsonQuery: { region },
      geoSearch,
      geocode,
    },
    sutochnoPilot: { regions },
  } = state;

  const isGeoLoading = selectIsGeoLoading(state);

  if (!geoSearch || isGeoLoading) {
    return 'empty';
  }

  const currentRegions = region?.value || [];
  const hasTargetRegion = regions.some(regionId => currentRegions.includes(regionId));

  if (hasTargetRegion && geocode.status !== EGeocodeStatus.Failed) {
    return 'target';
  }

  return 'nonTarget';
}
